import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import Layout from './Layout';

const PaymentFailure: React.FC = () => {
  const [searchParams] = useSearchParams();
  const quoteId = searchParams.get('quote_id');
  const reason = searchParams.get('reason');

  return (
    <Layout>
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card text-center">
              <div className="card-body py-5">
                <div className="mb-4">
                  <i className="fas fa-times-circle text-danger fa-4x"></i>
                </div>
                
                <h2 className="mb-3 text-danger">Payment Failed</h2>
                
                <p className="lead mb-4">
                  We were unable to process your payment.
                </p>
                
                {reason && (
                  <div className="alert alert-danger mb-4" role="alert">
                    <strong>Reason:</strong> {reason}
                  </div>
                )}
                
                <p className="text-muted mb-4">
                  Please try again or contact support if the problem persists.
                </p>
                
                <div className="d-grid gap-2 d-md-block">
                  {quoteId ? (
                    <Link 
                      to={`/payment/checkout/${quoteId}`} 
                      className="btn btn-primary me-md-2"
                    >
                      <i className="fas fa-redo me-2"></i>
                      Try Again
                    </Link>
                  ) : (
                    <Link to="/drafts" className="btn btn-primary me-md-2">
                      View Drafts
                    </Link>
                  )}
                  <Link to="/dashboard" className="btn btn-outline-secondary">
                    Return to Dashboard
                  </Link>
                </div>
                
                <div className="mt-4">
                  <p className="small text-muted">
                    Need help? Contact support at{' '}
                    <a href="mailto:support@purehd.com">support@purehd.com</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default PaymentFailure;